import React from 'react';
import { Text, Section, Link } from '@react-email/components';
import Layout, { LayoutTranslations } from './components/Layout';

export interface AppointmentConfirmedTranslations {
  title: string;
  greeting: string;
  bodyVisitor: string;
  bodyExhibitor: string;
  labelDate: string;
  labelTime: string;
  labelType: string;
  labelLocation: string;
  reminder: string;
  ctaText: string;
  signOff: string;
  teamSignature: string;
  typeInPerson: string;
  typeVirtual: string;
  typeHybrid: string;
  layout: LayoutTranslations;
}

interface AppointmentConfirmedProps {
  recipientName: string;
  otherPartyName: string;
  date: string;
  time: string;
  location?: string;
  type?: 'in-person' | 'virtual' | 'hybrid';
  isExhibitor?: boolean;
  translations: AppointmentConfirmedTranslations;
}

export default function AppointmentConfirmed({
  recipientName,
  otherPartyName,
  date,
  time,
  location,
  type = 'in-person',
  isExhibitor = false,
  translations: tx,
}: AppointmentConfirmedProps) {
  const typeLabels: Record<string, string> = {
    'in-person': tx.typeInPerson,
    'virtual': tx.typeVirtual,
    'hybrid': tx.typeHybrid,
  };

  return (
    <Layout previewText={tx.title} translations={tx.layout}>
      <Text style={heading}>{tx.title}</Text>
      <Text style={paragraph}>{tx.greeting} {recipientName},</Text>
      <Text style={paragraph}>
        {isExhibitor
          ? tx.bodyExhibitor.replace('{{name}}', otherPartyName)
          : tx.bodyVisitor.replace('{{name}}', otherPartyName)}
      </Text>

      <Section style={infoBox}>
        <Text style={infoLine}>{tx.labelDate}: {date}</Text>
        <Text style={infoLine}>{tx.labelTime}: {time}</Text>
        <Text style={infoLine}>{tx.labelType}: {typeLabels[type] || type}</Text>
        {location && <Text style={infoLine}>{tx.labelLocation}: {location}</Text>}
      </Section>

      <Text style={paragraph}>{tx.reminder}</Text>

      <Section style={ctaContainer}>
        <Link href="https://siportevent.com/dashboard/appointments" style={ctaButton}>
          {tx.ctaText}
        </Link>
      </Section>

      <Text style={paragraph}>
        {tx.signOff}<br />{tx.teamSignature}
      </Text>
    </Layout>
  );
}

const heading: React.CSSProperties = { fontSize: '24px', fontWeight: 700, color: '#059669', margin: '0 0 20px 0' };
const paragraph: React.CSSProperties = { fontSize: '16px', lineHeight: '1.6', color: '#374151', margin: '0 0 16px 0' };
const infoBox: React.CSSProperties = { backgroundColor: '#ecfdf5', borderLeft: '4px solid #10b981', padding: '16px 20px', margin: '20px 0', borderRadius: '0 4px 4px 0' };
const infoLine: React.CSSProperties = { fontSize: '15px', color: '#065f46', margin: '0 0 8px 0' };
const ctaContainer: React.CSSProperties = { textAlign: 'center' as const, margin: '30px 0' };
const ctaButton: React.CSSProperties = { display: 'inline-block', padding: '14px 28px', backgroundColor: '#2563eb', color: '#ffffff', textDecoration: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '16px' };
